import { Anchor, Link } from "@faire/web--source/ui/LinkAnchor";
import styled, { css } from "styled-components";

export const AccessibilityLinkCss = css`
  &:focus-visible {
    outline: solid;
    outline: revert;
  }
`;

export const AccessibilityLink = styled(Link)`
  ${AccessibilityLinkCss}
`;

export const AccessibilityAnchor = styled(Anchor)`
  ${AccessibilityLinkCss}
`;
